import { render } from "./PlatformMobile.vue?vue&type=template&id=628372e1&scoped=true&ts=true"
import script from "./PlatformMobile.vue?vue&type=script&lang=ts"
export * from "./PlatformMobile.vue?vue&type=script&lang=ts"

import "./PlatformMobile.vue?vue&type=style&index=0&id=628372e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628372e1"]])

export default __exports__